import { createTheme } from '@mui/material/styles';

const customShadows = [
    'none',
    '0 1px 2px 0 rgb(0 0 0 / 0.05)',                    // shadow-sm
    '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', // shadow
    '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', // shadow-md
    '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)', // shadow-lg
    '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)', // shadow-xl
    '0 25px 50px -12px rgb(0 0 0 / 0.25)',               // shadow-2xl
];

const defaultShadows = createTheme().shadows;

const mergedShadows = defaultShadows.map((shadow, index) => {
    const customShadow = customShadows[index];
    return typeof customShadow === 'undefined' ? shadow : customShadow;
});

export default mergedShadows;
